exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, " /deep/ cxScrollable {\n  width: calc(100% + 12px);\n  margin: 0 -6px;\n}\n /deep/ cxScrollable > div {\n  overflow-x: hidden;\n}\n /deep/ cxScrollable > div > table {\n  width: 100%;\n  margin: 0;\n}\nth:first-child,\ntd:first-child {\n  width: 300px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./~/@c4/sysman/src/app/sysman-package-versions/sysman-package-versions.component.less
// module id = 1474
// module chunks = 2